import { Box, Tab, Tabs } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import Divider from "@material-ui/core/Divider";
import { GeminiResult } from "../../../../models/log";
import ListItem from "@material-ui/core/ListItem";
import { ListLabel } from "../LogDetail";
import { ModelResultProps } from "../../../../config/modelsConfig";

const tabScrollButtonWidth = 30;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    models: {
      [theme.breakpoints.down(430)]: {
        fontSize: "4vw",
        display: "grid",
      },
    },
    tabs: {
      "& button": {
        minWidth: tabScrollButtonWidth,
      },
      "& .MuiTabScrollButton-root": {
        width: tabScrollButtonWidth,
      },
      "& .MuiTabScrollButton-root.Mui-disabled": {
        opacity: 0.3,
      },
    },
    resultDetails: {
      marginLeft: 10,
    },
  }),
);

export const GeminiDetails: React.FC<ModelResultProps> = (props) => {
  const modelResult = props.modelResult as GeminiResult;
  const classes = useStyles(props);
  const [resultSelected, setResultSelected] = useState(0);
  const item = modelResult.results?.[resultSelected];

  useEffect(() => {
    return () => {
      // Reset the result selected if the reference to the model result changes
      // as the component will show the information from another log.
      if (modelResult) setResultSelected(0);
    };
  }, [modelResult]);

  return (
    <>
      <ListItem className={classes.models}>
        <ListLabel title={"Answer"} value={modelResult.answer ? "True" : "False"} />
      </ListItem>
      <Divider />
      <ListItem className={classes.models}>
        <ListLabel title={"Elapsed Time"} value={`${modelResult.e2eElapsedTime} ms`} />
      </ListItem>
      <Divider />
      {item && (
        <>
          <ListItem className={classes.models}>
            <ListLabel title={"Results"} value="" />
          </ListItem>
          <ListItem className={classes.models}>
            <Tabs
              value={resultSelected}
              onChange={(_, newValue) => setResultSelected(newValue)}
              className={classes.tabs}
              indicatorColor="primary"
              textColor="primary"
              centered
              variant="scrollable"
              scrollButtons="auto"
            >
              {modelResult.results.map((_, index) => (
                <Tab key={index} label={index} />
              ))}
            </Tabs>
          </ListItem>
          <Box className={classes.resultDetails}>
            <ListItem className={classes.models}>
              <ListLabel title={"Answer"} value={`${item.answer}`} />
            </ListItem>
            <ListItem className={classes.models}>
              <ListLabel title={"System instruction hash"} value={`${item.systemInstructionHash}`} />
            </ListItem>
            <ListItem className={classes.models}>
              <ListLabel title={"System instruction name"} value={`${item.systemInstructionName}`} />
            </ListItem>
            <ListItem className={classes.models}>
              <ListLabel title={"Raw output"} value={`${item.rawOutput}`} />
            </ListItem>
            <ListItem className={classes.models}>
              <ListLabel title={"Model version"} value={`${item.checkpoint} ms`} />
            </ListItem>
            <ListItem className={classes.models}>
              <ListLabel title={"Max output tokens"} value={`${item.maxOutputTokens}`} />
            </ListItem>
            <ListItem className={classes.models}>
              <ListLabel title={"Temperature"} value={`${item.temperature}`} />
            </ListItem>
            <ListItem className={classes.models}>
              <ListLabel title={"Elapsed time"} value={`${item.elapsedTime} ms`} />
            </ListItem>
          </Box>
          <Divider />
        </>
      )}
    </>
  );
};
